import React from 'react';
import InsightsTableRow from '../_shared/InsightsTableRow';

const SearchTableRow = ({ number, rowData }) => (
  <InsightsTableRow
    number={number}
    item={rowData.term}
    amount={rowData.searches}
  />
);

export default SearchTableRow;
